import React from "react";
import About from "../components/About";
import Candidates from "../components/Candidates";
import Footer from "../components/Footer";

const Home = () => {
  return (
    <>
      <About />
      <Candidates />
      <Footer />
    </>
  );
};

export default Home;
